import { useMsal } from '@azure/msal-react'

export const ADMIN_ROLE_CLAIM = 'extension_Role'
export const ADMIN_ROLE = 'admin'

export const isAdminAccount = (claims?: Record<string, unknown>): boolean =>
  Object.entries(claims ?? {}).some(
    ([type, value]) =>
      type.toLowerCase() === ADMIN_ROLE_CLAIM.toLowerCase() &&
      value === ADMIN_ROLE
  )

export const useIsAdminAccount = (): boolean => {
  const { accounts } = useMsal()
  return isAdminAccount(accounts[0]?.idTokenClaims)
}
